module.exports = __webpack_public_path__ + "media/images/alf_logo-0e35833e9d86a1a29f27231fb0ce3efc.png";